/**
 * Parses cookies from document.cookie
 * Returns a map of cookie name to value
 */
export const parseCookies = (cookieString: string): Record<string, string> => {
  if (!cookieString) return {};

  const cookies: Record<string, string> = {};
  const pairs = cookieString.split(';');

  for (const pair of pairs) {
    const [name, ...valueParts] = pair.split('=');
    if (name && valueParts.length > 0) {
      cookies[name.trim()] = valueParts.join('=').trim();
    }
  }

  return cookies;
};

/**
 * Extracts clubCode from ace-zipdata cookie
 * Cookie format: "CA|91761|004" where third segment is clubCode
 * Returns undefined if cookie is missing or malformed
 */
export const getClubCodeFromCookie = (): string | undefined => {
  if (typeof document === 'undefined') return undefined;

  const cookies = parseCookies(document.cookie);
  const aceZipdata = cookies['ace-zipdata'];

  if (!aceZipdata) return undefined;

  const segments = aceZipdata.split('|');
  if (segments.length < 3) return undefined;

  const clubCode = segments[2]?.trim();
  if (!clubCode) return undefined;

  return clubCode;
};

/**
 * Normalizes clubCode by stripping leading zeros
 * e.g., "018" -> "18", "004" -> "4"
 */
export const normalizeClubCode = (clubCode: string): string => {
  return String(parseInt(clubCode.trim(), 10));
};
